import { fetchApi, trackError } from '@vend/utilities'

const getBackfillPairingPath = (registerId: string) =>
  `/api/1.0/cfd/backfill_pairing/${registerId}`

export const backfillCFDPairing = async (
  registerId?: string
): Promise<void> => {
  if (!registerId) {
    return
  }

  try {
    const response = await fetchApi(getBackfillPairingPath(registerId), {
      method: 'GET',
    })

    if (!response.ok) {
      trackBackfillError(
        registerId,
        new Error(`CFD pairing backfill failed with status ${response.status}`),
        {
          responseStatus: response.status,
          responseStatusText: response.statusText,
          responseUrl: response.url,
        }
      )
    }
  } catch (error) {
    trackBackfillError(registerId, error)
  }
}

const serializeError = (error: unknown) => {
  if (error instanceof Error) {
    return {
      name: error.name,
      message: error.message,
      stack: error.stack,
    }
  }

  return error
}

const trackBackfillError = (
  registerId: string,
  error: unknown,
  metadata: Record<string, string | number | undefined> = {}
) => {
  trackError('[CFD] Failed to backfill pairing', {
    data: {
      registerId,
      ...metadata,
      error: serializeError(error),
    },
  })
}
